
//////////////////////////////view switching using state method

import { useState } from "react";
import { ArrowLeft, ChevronRight, Cpu, Monitor, ShieldCheck, LoaderCircle, Loader } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";


export default function VendorCapability() {
  const location = useLocation();
  const [currentView, setCurrentView] = useState(
    location.state?.view || "menu"
  );
  const navigate = useNavigate();
  const [loadedImages, setLoadedImages] = useState({});
  const [hardwareExpandedType, setHardwareExpandedType] = useState(null);
  const [softwareExpandedType, setSoftwareExpandedType] = useState(null);


  const items = [
    {
      title: "Hardware Validation Capability",
      icon: Cpu,
      view: "hardware",
    },
    {
      title: "Software Validation Capability",
      icon: Monitor,
      view: "software",
    },
    {
      title: "Certification Capability",
      icon: ShieldCheck,
      view: "certification",
    },
  ];

  const products = [
    { name: "TV", img: "/tv.png", route: "/tv-capability" },
    { name: "Monitor", img: "/monitor.png", route: "/monitor-capability" },
    { name: "Professional Display", img: "/lamp.png", route: "/pd-capability" },
    { name: "AVA", img: "/headphones.png", route: "/ava-capability" },
  ];
  const pdswRoutes = {
    "PD_Signage & IWB": "/pdsignage-software-capability",
    "PD_RGB LED": "/pdrgb-software-capability",
    "PD_AIO": "/pdaio-software-capability",
    "PD_EPD": "/pdepd-software-capability",
  };

  const avaswRoutes = {
    "AVA_Audio": "/avaaudio-software-capability",
    "AVA_Headphone": "/avaheadphone-software-capability",
  };

  const pdhwRoutes = {
    "PD_Signage & IWB": "/pdsignage-hardware-capability",
    "PD_RGB LED": "/pdrgb-hardware-capability",
    "PD_AIO": "/pdaio-hardware-capability",
    "PD_EPD": "/pdepd-hardware-capability",
  };

  const avahwRoutes = {
    "AVA_Audio": "/avaaudio-hardware-capability",
    "AVA_Headphone": "/avaheadphone-hardware-capability",
  };

  const HardwareValidationView = () => (
    <div className="min-h-screen bg-[#0f1b2b] text-white flex justify-left">
      <div className="w-full max-w-10xl px-6 pt-6">


        {/* Header */}
        <div className="flex items-center gap-4 mb-10">
          <ArrowLeft
            onClick={() => setCurrentView("menu")}
            className="sm:w-8 w-6 sm:h-8 h-6 cursor-pointer text-white"
          />
          <h1 className="sm:text-2xl text-sm font-bold">
            Hardware Validation Capability
          </h1>
        </div>

        <h2 className="sm:text-xl text-sm font-semibold mb-4 ml-2">Product Type</h2>

        <div className="flex flex-col gap-4">
          {["TV", "Monitor", "PD", "AVA"].map((item, i) => (
            <div key={i}>

              {/* MAIN ITEM */}
              <div
                onClick={() => {
                  if (item === "Monitor") {
                    navigate("/monitor-hardware-capability");
                  } else if (item === "TV") {
                    navigate("/tv-hardware-capability");
                  } else if (item === "PD" || item === "AVA") {
                    setHardwareExpandedType(prev =>
                      prev === item ? null : item
                    );
                  }
                }}
                className="bg-[#1b2a3c] p-6 rounded-xl shadow-md hover:bg-[#22354b] transition sm:text-lg text-sm font-medium cursor-pointer"
              >
                {item}
              </div>

              {/* DROPDOWN */}
              {hardwareExpandedType === "PD" && item === "PD" && (
                <div className="ml-6 mt-2 flex flex-col gap-2">
                  {Object.keys(pdhwRoutes).map((sub, idx) => (
                    <div
                      key={idx}
                      onClick={() => navigate(pdhwRoutes[sub])}
                      className="bg-[#22354b] p-3 rounded-lg cursor-pointer hover:bg-[#2c4a6a] text-sm"
                    >
                      {sub}
                    </div>
                  ))}
                </div>
              )}

              {hardwareExpandedType === "AVA" && item === "AVA" && (
                <div className="ml-6 mt-2 flex flex-col gap-2">
                  {Object.keys(avahwRoutes).map((sub, idx) => (
                    <div
                      key={idx}
                      onClick={() => navigate(avahwRoutes[sub])}
                      className="bg-[#22354b] p-3 rounded-lg cursor-pointer hover:bg-[#2c4a6a] text-sm"
                    >
                      {sub}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  /* ---------- Switch Views ---------- */
  if (currentView === "hardware") {
    return <HardwareValidationView />;
  }

  /*----------------------Software Validation Screen------------*/
  // const SoftwareValidationView = () => (
  //   <div className="min-h-screen bg-[#0f1b2b] text-white flex justify-left">
  //     <div className="w-full max-w-10xl px-6 pt-6">


  //       {/* Header */}
  //       <div className="flex items-center gap-4 mb-10">
  //         <ArrowLeft
  //           onClick={() => setCurrentView("menu")}
  //           className="sm:w-8 w-6 sm:h-8 h-6 cursor-pointer text-white"
  //         />
  //         <h1 className="sm:text-2xl text-sm font-bold">
  //           Software Validation Capability
  //         </h1>
  //       </div>

  //       <h2 className="sm:text-xl text-sm font-semibold mb-4 ml-2">Product Type</h2>

  //       <div className="flex flex-col gap-4">
  //         {["TV", "Monitor", "PD", "AVA"].map((item, i) => (
  //           <div key={i}>

  //             <div
  //               onClick={() => {
  //                 if (item === "Monitor") {
  //                   navigate("/monitor-software-capability");
  //                 } else if (item === "TV") {
  //                   navigate("/tv-software-capability");
  //                 } else if (item === "PD" || item === "AVA") {
  //                   setSoftwareExpandedType(prev =>
  //                     prev === item ? null : item
  //                   );
  //                 }
  //               }}
  //               className={`bg-[#1b2a3c] p-6 rounded-xl shadow-md transition sm:text-lg text-sm font-medium
  //               ${item === "Monitor" || item === "TV" || item === "PD" || item === "AVA"
  //                   ? "hover:bg-[#22354b] cursor-pointer"
  //                   : "opacity-60"
  //                 }`}
  //             >
  //               {item}
  //             </div>

  //             {/* PD DROPDOWN */}
  //             {softwareExpandedType === "PD" && item === "PD" && (
  //               <div className="ml-6 mt-2 flex flex-col gap-2">
  //                 {Object.keys(pdswRoutes).map((sub, idx) => (
  //                   <div
  //                     key={idx}
  //                     onClick={() => navigate(pdswRoutes[sub])}
  //                     className="bg-[#22354b] p-3 rounded-lg cursor-pointer hover:bg-[#2c4a6a] text-sm"
  //                   >
  //                     {sub}
  //                   </div>
  //                 ))}
  //               </div>
  //             )}

  //             {softwareExpandedType === "AVA" && item === "AVA" && (
  //               <div className="ml-6 mt-2 flex flex-col gap-2">
  //                 {Object.keys(avaswRoutes).map((sub, idx) => (
  //                   <div
  //                     key={idx}
  //                     onClick={() => navigate(avaswRoutes[sub])}
  //                     className="bg-[#22354b] p-3 rounded-lg cursor-pointer hover:bg-[#2c4a6a] text-sm"
  //                   >
  //                     {sub}
  //                   </div>
  //                 ))}
  //               </div>
  //             )}
  //           </div>
  //         ))}
  //       </div>
  //     </div>
  //   </div>
  // );

  /*----------------------Software Validation Screen------------*/
const SoftwareValidationView = () => {

  /*
   * Convert the selected product/subtype into
   * the URL that should be displayed in browser.
   */
  const softwareRoutes = {
    TV: "/tv-software-capability",

    Monitor: "/mnt-software-capability",

    "PD_Signage & IWB":
      "/pd_signage_iwb-software-capability",

    "PD_RGB LED":
      "/pd_rgb_led-software-capability",

    PD_AIO:
      "/pd_aio-software-capability",

    PD_EPD:
      "/pd_epd-software-capability",

    AVA_Audio:
      "/ava_audio-software-capability",

    AVA_Headphone:
      "/ava_headphone-software-capability",
  };

  /*
   * Navigate to the common component but use
   * the product-specific URL.
   */
  const handleSoftwareProductClick = (
    productType,
    parentProductType
  ) => {

    const route =
      softwareRoutes[productType];

    if (!route) {
      console.error(
        "Software route not found for:",
        productType
      );

      return;
    }

    navigate(route, {
      state: {
        productType,
        parentProductType,
      },
    });
  };


  return (
    <div className="min-h-screen bg-[#0f1b2b] text-white flex justify-left">

      <div className="w-full max-w-10xl px-6 pt-6">

        {/* Header */}
        <div className="flex items-center gap-4 mb-10">

          <ArrowLeft
            onClick={() =>
              setCurrentView("menu")
            }
            className="sm:w-8 w-6 sm:h-8 h-6 cursor-pointer text-white"
          />

          <h1 className="sm:text-2xl text-sm font-bold">
            Software Validation Capability
          </h1>

        </div>


        <h2 className="sm:text-xl text-sm font-semibold mb-4 ml-2">
          Product Type
        </h2>


        <div className="flex flex-col gap-4">

          {[
            "TV",
            "Monitor",
            "PD",
            "AVA",
          ].map((item, i) => (

            <div key={i}>

              {/* ==========================================
                  MAIN PRODUCT TYPE
              ========================================== */}

              <div
                onClick={() => {

                  /*
                   * TV
                   */
                  if (item === "TV") {

                    handleSoftwareProductClick(
                      "TV",
                      "TV"
                    );

                    return;
                  }


                  /*
                   * Monitor
                   *
                   * Browser:
                   * /mnt-software-capability
                   *
                   * API:
                   * MNT
                   */
                  if (item === "Monitor") {

                    handleSoftwareProductClick(
                      "Monitor",
                      "Monitor"
                    );

                    return;
                  }
                  /*
                   * PD / AVA
                   *
                   * Don't navigate immediately.
                   * Open subtype dropdown.
                   */
                  if (
                    item === "PD" ||
                    item === "AVA"
                  ) {

                    setSoftwareExpandedType(
                      prev =>
                        prev === item
                          ? null
                          : item
                    );
                  }

                }}

                className={`
                  bg-[#1b2a3c]
                  p-6
                  rounded-xl
                  shadow-md
                  transition
                  sm:text-lg
                  text-sm
                  font-medium

                  ${
                    item === "Monitor" ||
                    item === "TV" ||
                    item === "PD" ||
                    item === "AVA"
                      ? "hover:bg-[#22354b] cursor-pointer"
                      : "opacity-60"
                  }
                `}
              >
                {item}
              </div>

              {/* ==========================================
                  PD DROPDOWN
              ========================================== */}
              {softwareExpandedType === "PD" &&
                item === "PD" && (
                <div className="ml-6 mt-2 flex flex-col gap-2">
                  {[
                    "PD_Signage & IWB",
                    "PD_RGB LED",
                    "PD_AIO",
                    "PD_EPD",
                  ].map((sub, idx) => (
                    <div
                      key={idx}
                      onClick={() => {
                        handleSoftwareProductClick(
                          sub,
                          "PD"
                        );

                      }}
                      className="
                        bg-[#22354b]
                        p-3
                        rounded-lg
                        cursor-pointer
                        hover:bg-[#2c4a6a]
                        text-sm
                      "
                    >
                      {sub}
                    </div>
                  ))}
                </div>
              )}

              {/* ==========================================
                  AVA DROPDOWN
              ========================================== */}
              {softwareExpandedType === "AVA" &&
                item === "AVA" && (
                <div className="ml-6 mt-2 flex flex-col gap-2">
                  {[
                    "AVA_Audio",
                    "AVA_Headphone",
                  ].map((sub, idx) => (
                    <div
                      key={idx}
                      onClick={() => {
                        handleSoftwareProductClick(
                          sub,
                          "AVA"
                        );

                      }}
                      className="
                        bg-[#22354b]
                        p-3
                        rounded-lg
                        cursor-pointer
                        hover:bg-[#2c4a6a]
                        text-sm
                      "
                    >
                      {sub}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

  /* ---------- Switch Views ---------- */
  if (currentView === "software") {
    return <SoftwareValidationView />;
  }

  /* ---------- Hardware Validation Screen ---------- */
  const renderCertificationCapability = () => (
    <div className="min-h-screen bg-[#0f1b2b] text-white flex justify-left">
      <div className="w-full max-w-10xl px-6 pt-6">

        {/* Header */}
        <div className="flex items-center gap-4 mb-10">
          <ArrowLeft
            onClick={() => setCurrentView("menu")}
            className="sm:w-8 w-6 sm:h-8 h-6 cursor-pointer text-white"
          />
          <h1 className="sm:text-2xl text-sm font-bold">
            Certification Capability
          </h1>
        </div>

        <h2 className="sm:text-2xl text-sm font-bold mb-4 ml-5">Product Type</h2>
        <div className="flex flex-col gap-4">
          {products.map((item, i) => (
            <div
              key={i}
              onClick={() => navigate(item.route)}
              className="bg-[#1b2a3c] sm:p-3 p-2 rounded-xl shadow-md hover:bg-[#22354b]
                 transition flex items-center justify-between cursor-pointer"
            >
              {/* Label */}
              <span className="sm:text-xl text-sm font-medium ml-3">
                {item.name}
              </span>

              {/* Image container */}
              <div className="relative sm:w-32 sm:h-24 w-24 h-20 flex items-center justify-center pointer-events-none">
                {!loadedImages[item.name] && (
                  <LoaderCircle className="absolute animate-spin text-gray-300 w-6 h-6" />
                )}

                <img
                  src={item.img}
                  alt={item.name}
                  onLoad={() =>
                    setLoadedImages((prev) => ({ ...prev, [item.name]: true }))
                  }
                  className={`object-contain sm:w-32 sm:h-24 w-24 h-20 transition-opacity duration-500
                      ${loadedImages[item.name] ? "opacity-100" : "opacity-0"}`}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  /* ---------- Switch Views ---------- */
  if (currentView === "certification") {
    return renderCertificationCapability();
  }

  /* ---------- Main Menu Screen ---------- */
  return (
    <div className="min-h-screen bg-[#0f1b2b] text-white flex justify-left">
      <div className="w-full max-w-10xl px-6 pt-6 ">

        {/* Header */}
        <div className="flex items-center gap-4 mb-10">
          <ArrowLeft
            onClick={() => navigate("/dashboard")}
            className="sm:w-8 w-6 sm:h-8 h-6 cursor-pointer text-white"
          />

          <h1 className="sm:text-2xl text-lg font-bold ">Vendor Capability</h1>
        </div>

        {/* Cards */}
        <div className="flex flex-col sm:gap-8 gap-4 font-medium">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                onClick={() => item.view && setCurrentView(item.view)}
                className="flex items-center justify-between 
                           bg-[#1b2a3c] rounded-xl p-4
                           shadow-md hover:bg-[#22354b]
                           transition duration-200 cursor-pointer"
              >
                <div className="flex items-center gap-4">
                  <div className="bg-[#19324a] p-3 rounded-full">
                    <Icon className="sm:w-10 sm:h-10 w-5 h-5 text-blue-400" />
                  </div>

                  <span className="text-sm sm:text-lg text-white whitespace-rowrap">
                    {item.title}
                  </span>
                </div>
                <ChevronRight className="text-gray-400" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
